import { defineElement } from "@acng/frontend-bounty/dom/custom.js";
import { defineAttrCompiler, defineElementCompiler } from "../../service/compile.js";
import { REGISTRY_ELEMENT, RESOURCE_HIDDEN } from "../resource.js";
import { NamespaceUtility } from "./namespace.js";
import { CommonElementDefinition, defineCustomWidget } from "../../service/widget.js";
import { removeNode } from "@acng/frontend-bounty";
export class FeatureUtility extends NamespaceUtility {
    /**
     * @deprecated use isHidden
     */
    get isEnabled() {
        return !this[REGISTRY_ELEMENT][RESOURCE_HIDDEN];
    }
    get isHidden() {
        return !!this[REGISTRY_ELEMENT][RESOURCE_HIDDEN];
    }
    /**
     * @param {string} name
     * @param {boolean} [isAttribute]
     */
    defineRemoveWhenHidden(name, isAttribute) {
        /**
         * @type {(element: Element) => unknown}
         */
        const compileRemove = (element) => this.isHidden && removeNode(element);
        if (isAttribute) {
            defineAttrCompiler(name, compileRemove);
        }
        else {
            defineElementCompiler(name, () => compileRemove);
        }
    }
    /**
     * @param {import("../resource.js").ConfigCallback | null} callbackConfig
     *
    set config(callbackConfig) {
      setConfig(this[REGISTRY_ELEMENT], callbackConfig)
      callConfig(this[REGISTRY_ELEMENT]);
    }
  
    get config() {
      return this[REGISTRY_ELEMENT][RESOURCE_CONFIG] ?? null;
    }*/
    /**
     * @template {import("../../model/widget").Widget} T
     * @param {string} name
     * @param {import("../widget.js").WidgetConstructor<T>} CustomWidget
     * @param {readonly import("@acng/frontend-relativity").Context<unknown>[]} [contexts]
     */
    defineWidget(name, CustomWidget, contexts) {
        defineCustomWidget(this, name, CustomWidget, contexts);
    }
    /**
     * @template {typeof HTMLElement} T
     * @param {string} name
     * @param {T} Element
     * @param {readonly import("@acng/frontend-relativity").Context<unknown>[]} [contexts]
     */
    defineElement(name, Element, contexts) {
        const removeIfHidden = CommonElementDefinition(this, Element, contexts)(name);
        defineElementCompiler(name, () => removeIfHidden);
    }
    /**
     * @deprecated
     * @template {typeof HTMLElement} T
     * @param {string} name
     * @param {(name: string) => Promise<T>} loader
     */
    defineElementLoader(name, loader) {
        defineElementCompiler(name, () => {
            const willBeDefined = this.isHidden
                ? false
                : loader(name).then((Constructor) => defineElement(name, Constructor));
            return (element, promises) => {
                if (willBeDefined) {
                    promises.push(willBeDefined);
                }
                if (this.isHidden) {
                    element.remove();
                }
            };
        });
    }
}
